/* eslint-disable import/no-anonymous-default-export */
export default (unapproved = [], action) => {
  switch (action.type) {
    case "UNAPPROVED_ADVICE":
      return action.payload;
    case "APPROVE_ADVICE":
      return unapproved.filter((data) => data._id !== action.payload);
    case "DELETE_ADVICE":
      return unapproved.filter((data) => data._id !== action.payload);

    default:
      return unapproved;
  }
};
